export default {
  title: 'VAT by company / practice',
  defaultVat: 'Default VAT',
  explanation: 'The default VAT applies unless a company has its own setting. '
    + 'Company VAT rates are percentages of the service price.',
  inherit: 'Use default VAT',
  disabled: 'VAT disabled',
  enabled: 'Use company VAT rate',
  rate: 'VAT rate (%)',
  rateError: 'Enter a VAT rate between 0 and 100.',
  loadError: 'Could not load company VAT settings. Reopen the form to try again.',
};
